import { HeaderBar } from '@/components/AssetsPage/HeaderBar';
import { AssetsPageObjectModel } from '@/poms/assetsPageObjectModel';
import { styled } from '@mui/material';
import { ReactNode } from 'react';

const StyledHeaderBar = styled(HeaderBar)(({ theme }) => ({
  border: '1px solid transparent',
  margin: '6px 6px 0 0',
  gap: '6px',
  textWrap: 'nowrap',
  color: theme.palette.text.primary,
  a: {
    color: theme.palette.text.primary,
    textDecoration: 'none',
    display: 'inline-flex',
    alignItems: 'center',
  },
}));

export const SectionHeader = ({ children }: { children: ReactNode }) => {
  return <StyledHeaderBar data-testid={AssetsPageObjectModel.SectionHeader}>{children}</StyledHeaderBar>;
};
